import { useEffect, useRef } from "react";
import { showNotification } from "@mantine/notifications";
import { useNavigate } from "react-router-dom";
import { notifyListRefresh } from "../context/tabContext";
import { requestNotificationInboxRefresh } from "./useNotificationInbox";

const useNotificationSocket = (socket) => {
  const navigate = useNavigate();
  const reconcileTimerRef = useRef(null);

  useEffect(() => {
    if (!socket) return;

    const handleNew = (payload) => {
      showNotification({
        title: payload?.title ?? "Notification",
        message: (payload?.body ?? "").replace(/<[^>]+>/g, "").slice(0, 120),
        color: "blue",
        onClick: () => navigate("/notifications"),
      });
      requestNotificationInboxRefresh({ incrementUnread: 1 });
      notifyListRefresh("/notifications");
      if (reconcileTimerRef.current) {
        window.clearTimeout(reconcileTimerRef.current);
      }
      reconcileTimerRef.current = window.setTimeout(() => {
        requestNotificationInboxRefresh();
        notifyListRefresh("/notifications");
        reconcileTimerRef.current = null;
      }, 1000);
    };

    socket.on("notification:new", handleNew);
    return () => {
      socket.off("notification:new", handleNew);
      if (reconcileTimerRef.current) {
        window.clearTimeout(reconcileTimerRef.current);
        reconcileTimerRef.current = null;
      }
    };
  }, [socket, navigate]);
};

export default useNotificationSocket;
